export const AdvertisementSection = ({ news1 }) => {
  return (
    <>
      <div className="bg-white rounded-2xl border-1 border-gray-100 overflow-hidden">
        {/* Top Image */}
        <img src={news1} alt="Ad" className="w-full h-[420px] object-cover" />

        {/* Content */}
        <div className="text-center p-6">
          <h3 className="text-3xl font-semibold tracking-wide mb-2">JEWEL</h3>

          <p className="text-gray-600 text-sm tracking-widest mb-4">
            PRIVATE RESIDENCES GOLD COAST
          </p>

          <p className="text-gray-700 text-sm mb-6">
            YOUR FUTURE BEACHFRONT RESIDENCE IS READY TO BE EXPERIENCED
          </p>

          <button className="bg-[#1A3B66] text-white px-6 py-3 rounded-md font-semibold text-sm hover:bg-[#2A4B76] transition">
            ENQUIRE NOW
          </button>

          <div className="mt-6 text-xs text-gray-500">TOTAL PROPERTY GROUP</div>
        </div>
      </div>
    </>
  );
};
